import React from "react";
import Button from "components/button";
import UseContext from "hooks/useContext";
import LoadingButton from "../../components/button/loading";

const FooterButton = ({ oC1, oC2, isLoading }) => {
    const { page } = UseContext();

    if (page === 10) {
        return isLoading ? (
            <LoadingButton size={"LG"}>Création de la mission</LoadingButton>
        ) : (
            <Button size={"LG"} onClick={oC2}>Confirmer</Button>
        );
    }

    return <Button size={"LG"} onClick={oC1}>Suivant</Button>;
};

export default FooterButton;
